import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const SmartDefaultRoute: React.FC = () => {
  const { hasPermission, isSubAccount } = useAuth();

  // If it's a main account, go to dashboard
  if (!isSubAccount) {
    return <Navigate to="/app/dashboard" replace />;
  }

  // For sub-accounts, find the first available page
  const availableRoutes = [
    { path: "/app/dashboard", permission: "dashboard" },
    { path: "/app/students", permission: "students" },
    { path: "/app/staff", permission: "staff" },
    { path: "/app/classes-events", permission: "classes" },
    { path: "/app/events", permission: "events" },
    { path: "/app/attendance", permission: "attendance" },
    { path: "/app/messaging", permission: "messaging" },
    { path: "/app/sms", permission: "messaging" },
    { path: "/app/leads", permission: "leads" },
    { path: "/app/forms", permission: "forms" },
    { path: "/app/waivers", permission: "waivers" },
  ];

  for (const route of availableRoutes) {
    if (hasPermission(route.permission)) {
      return <Navigate to={route.path} replace />;
    }
  }

  // If no permissions, show access denied message
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6 text-center">
        <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 mb-4">
          <svg
            className="h-6 w-6 text-yellow-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
            />
          </svg>
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          No Permissions Assigned
        </h3>
        <p className="text-sm text-gray-500 mb-4">
          You don't have access to any pages yet. Please contact your
          administrator to assign permissions to your account.
        </p>
      </div>
    </div>
  );
};

export default SmartDefaultRoute;
